import React from 'react'
import I18n from 'translations/i18n'
import { Flex, Text } from '@jisr-hr/design-system'

import Styles from '../ProposedCorrectionTime.module.css'
import PunchOption from './PunchOption'

const CorrectionPunch = (props) => (
  <Flex
    flexCol
    className={Styles.correctionPunch}
  >
    <Text
      typography="paragraph14"
      color="var(--color-natural-gray-dark-new)"
    >
      {I18n.t('proposed_correction')}
    </Text>

    <PunchOption {...props} />
  </Flex>
)

export default CorrectionPunch
